// Автоматически сгенерировано. Не редактировать!
const PopoverComponentCss = `im-popover {
  --popover-violet: hsl(260, 90%, 64%);
  --popover-violet-light: hsl(260, 90%, 80%);
  --popover-green: hsl(150, 90%, 40%);
  --popover-green-light: hsl(150, 66%, 65%);
  --popover-grey: hsl(210, 8%, 48%);
  --popover-grey-light2: hsl(210, 8%, 88%);
  --popover-blue: hsl(200, 64%, 48%);
  --popover-blue-light: hsl(200, 64%, 72%);
  --popover-blue-light2: hsl(200, 64%, 88%);
  --popover-blue-light3: hsl(200, 64%, 96%);
  --popover-blue-dark: hsl(200, 64%, 16%);
  --popover-red: hsl(354, 90%, 64%);
  --popover-red-light: hsl(200, 64%, 72%);
  --popover-orange: hsl(40, 90%, 50%);
  --popover-orange-light: hsl(40, 90%, 66%);
  --popover-color-success: var(--popover-green-light);
  --popover-color-info: var(--popover-blue-light);
  --popover-color-warning: var(--popover-orange-light);
  --popover-color-error: var(--popover-red-light);
  --popover-color-voting: var(--popover-violet-light);
  display: block;
  position: fixed;
  /* ← хост теперь якорь */
  right: var(--popover-right, 16px);
  bottom: var(--popover-bottom, 16px);
  z-index: var(--popover-z, 1000);
  font-size: 16px;
  /*font-family: "SourceSansPro", sans-serif;*/
  --popover-wrapper-border-color: var(--popover-blue);
  --popover-header-bg-color: var(--popover-blue-light);
}
im-popover :where(.popover-button) {
  --svg-fill: var(--popover-blue);
}
im-popover[data-hover-open="true"] {
  --popover-wrapper-bg-color: var(--popover-blue-light);
  --popover-wrapper-border-color: var(--popover-blue);
}
im-popover[data-hover-open="true"] .popover-button,
im-popover[data-hover-open="true"] .popover-button:hover {
  --svg-fill: white;
}
im-popover:has(.success) {
  --popover-header-color: black;
  --popover-header-bg-color: var(--popover-color-success);
  --popover-wrapper-border-color: var(--popover-green);
}
im-popover:has(.success) :where(.popover-button) {
  --svg-fill: var(--popover-green);
}
im-popover:has(.success):where([data-hover-open="true"]) {
  --popover-wrapper-bg-color: var(--popover-color-success);
}
im-popover:has(.info) {
  --popover-header-color: black;
  --popover-header-bg-color: var(--popover-color-info);
  --popover-wrapper-border-color: var(--popover-blue);
}
im-popover:has(.info) :where(.popover-button) {
  --svg-fill: var(--popover-blue);
}
im-popover:has(.info):where([data-hover-open="true"]) {
  --popover-wrapper-bg-color: var(--popover-color-info);
}
im-popover:has(.warning) {
  --popover-header-color: black;
  --popover-header-bg-color: var(--popover-color-warning);
  --popover-wrapper-border-color: var(--popover-orange);
}
im-popover:has(.warning) :where(.popover-button) {
  --svg-fill: var(--popover-orange);
}
im-popover:has(.warning):where([data-hover-open="true"]) {
  --popover-wrapper-bg-color: var(--popover-color-warning);
}
im-popover:has(.error) {
  --popover-header-color: black;
  --popover-header-bg-color: var(--popover-color-error);
  --popover-wrapper-border-color: var(--popover-red);
}
im-popover:has(.error) :where(.popover-button) {
  --svg-fill: var(--popover-red);
}
im-popover:has(.error):where([data-hover-open="true"]) {
  --popover-wrapper-bg-color: var(--popover-color-error);
}
im-popover:has(.voting) {
  --popover-header-color: black;
  --popover-header-bg-color: var(--popover-color-voting);
  --popover-wrapper-border-color: var(--popover-violet);
}
im-popover:has(.voting) :where(.popover-button) {
  --svg-fill: var(--popover-violet);
}
im-popover:has(.voting):where([data-hover-open="true"]) {
  --popover-wrapper-bg-color: var(--popover-color-voting);
}
im-popover .trigger[hidden] {
  display: none;
}
im-popover .popover-wrapper {
  display: flex;
  align-items: center;
  border: 2px solid var(--popover-wrapper-border-color);
  border-radius: 8px;
  padding: 8px;
  background-color: var(--popover-wrapper-bg-color, white);
  box-shadow: var(--popover-shadow, 0 1px 4px rgba(0, 0, 0, 0.15));
  overflow: hidden;
}
im-popover .popover-button {
  flex-shrink: 0;
  width: var(--popover-button-size, 32px);
  height: var(--popover-button-size, 32px);
  background-color: transparent !important;
  --svg-size: 32px;
  padding: 0 !important;
}
im-popover .panel {
  position: absolute;
  /* позиционируется от im-popover */
  background: var(--popover-bg, white);
  color: var(--popover-color, black);
  border: var(--popover-border);
  border-radius: var(--popover-radius, 8px);
  box-shadow: var(--popover-shadow, 0 1px 4px rgba(0, 0, 0, 0.15));
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
im-popover .panel.is-open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}
im-popover .popover-hover {
  position: static;
  width: var(--popover-hover-width);
  max-width: var(--popover-hover-max-width, 0);
  height: var(--popover-hover-height);
  max-height: var(--popover-hover-max-height);
  box-shadow: none;
  background: transparent;
  padding: 0;
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s, max-width 0.3s, padding 0.3s;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
}
im-popover .popover-hover.is-open {
  width: var(--popover-hover-open-width, auto);
  max-width: var(--popover-hover-open-max-width, 500px);
  padding: 0 8px;
}
im-popover .popover-hover h3 {
  font-size: inherit;
}
im-popover .popover-hover .thumb-up,
im-popover .popover-hover .thumb-down {
  background-color: transparent;
  transition-property: border-color;
  border: 1px solid transparent;
  --svg-fill: white;
}
im-popover .popover-hover .thumb-up:hover,
im-popover .popover-hover .thumb-down:hover {
  background-color: transparent;
  border: 1px solid white;
}
im-popover .popover-full {
  min-width: var(--popover-main-min-width);
  width: var(--popover-main-width, 400px);
  max-width: var(--popover-main-max-width);
  min-height: var(--popover-main-min-height);
  height: var(--popover-main-height);
  max-height: var(--popover-main-max-height);
  bottom: calc(100% + var(--popover-gap, 8px));
  /* сверху от кнопки */
  right: var(--popover-main-right, -400px);
  transition: var(--popover-main-transition, opacity 0.3s ease, transform 0.3s ease, visibility 0.3s, right 0.3s);
}
im-popover .popover-full.is-open {
  width: var(--popover-main-open-width, 400px);
  right: var(--popover-main-open-right, 0);
  bottom: var(--popover-main-open-bottom, calc(100% + var(--popover-gap, 8px)));
}
im-popover .popover-full .thumb-up,
im-popover .popover-full .thumb-down {
  background-color: transparent;
  --svg-fill: var(--popover-blue);
}
im-popover .popover-full .thumb-up:hover,
im-popover .popover-full .thumb-down:hover {
  --svg-fill: white;
}
im-popover .popover-hover-title {
  margin: 0;
}
im-popover .main-content {
  --dd-height: 40px;
  --dd-width: 100%;
}
im-popover .main-content__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  /*color: var(--popover-header-color,white);*/
  background-color: var(--popover-header-bg-color, var(--popover-violet-light));
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
im-popover .main-content__header h2 {
  font-size: 18px;
  font-weight: normal;
  margin: 0;
}
im-popover .main-content__body {
  padding: 16px;
}
im-popover .main-content__body .decision-label {
  font-size: 14px;
}
im-popover .popover-close {
  /* --svg-fill: var(--popover-blue-dark);*/
}
im-popover textarea {
  max-width: 100%;
  border: 1px solid var(--popover-grey-light2);
  padding: 8px;
  resize: none;
}
im-popover .popover-route-wrapper {
  background-color: var(--popover-blue-light3);
  padding: 16px;
}
im-popover .change-route.btn,
im-popover .cancel-change-route.btn {
  margin-left: 8px;
}
im-popover .change-route.btn:hover,
im-popover .cancel-change-route.btn:hover {
  background: none;
  --svg-fill: var(--popover-blue);
}
im-popover :where(.btn, .btp1, .btp2, .btp3) {
  min-height: 32px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--popover-blue);
  font-family: inherit;
  padding: 0 32px;
  border-radius: 6px;
  background: var(--popover-blue-light2);
  border: none;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.3s, color 0.3s, background-color 0.3s, transform 0.1s;
  transition-delay: 0.3s, 0s, 0s, 0s;
}
im-popover :where(.btn, .btp1, .btp2, .btp3):active {
  transform: scale(0.95);
}
im-popover .btn:hover,
im-popover .btp1:hover {
  color: white;
  --svg-fill: white;
  background: var(--popover-blue);
}
im-popover .btp2 {
  color: var(--popover-grey-light2);
  background-color: var(--popover-grey-light2);
}
im-popover .btp2:hover {
  color: white;
  --svg-fill: white;
  background: var(--popover-grey);
}
im-popover .btp3 {
  text-decoration: underline;
  background: transparent;
}
im-popover .btp3:hover {
  color: var(--popover-blue);
  --svg-fill: var(--popover-blue);
  background: var(--popover-blue-light2);
}
im-popover .btn-icon {
  min-height: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  cursor: pointer;
}
im-popover .btn-unset {
  min-height: 0;
  background: none;
  padding: 0;
}
im-popover .btn-unset:hover {
  background: none;
}
`;

export { PopoverComponentCss };
